import React, { Fragment } from 'react';
import { List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';

type ListItemType = {
  primary: string;
  secondary: any;
  icon?: React.ReactNode;
};

interface IProps {
  list: Array<ListItemType>;
}

const DetailsList: React.FC<IProps> = ({ list }: IProps) => {
  return (
    <List>
      {list.map((listItem: ListItemType, index: number) => (
        <ListItem key={index}>
          {listItem.icon && <ListItemIcon>{listItem.icon}</ListItemIcon>}
          <ListItemText primary={listItem.primary} secondary={listItem.secondary} />
        </ListItem>
      ))}
    </List>
  );
};

export default DetailsList;
